<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";

    import ReviewItemFrame from "./ReviewItemFrame.svelte";
</script>

<ReviewItemFrame>
    <BaseSkeleton slot="author" width="40px" height="12px" />

    <BaseSkeleton slot="verified-buyer" width="40px" height="12px" />

    <BaseSkeleton slot="rating" width="80px" height="16px" />

    <BaseSkeleton slot="vote" width="40px" height="18px" />

    <BaseSkeleton slot="date" width="80px" height="18px" />

    <BaseSkeleton slot="title" width="220px" height="14x" />

    <BaseSkeleton slot="text" width="100%" height="20px" />

    <div slot="images" class="images">
        {#each [1, 2, 3] as _}
            <BaseSkeleton width="70px" height="70px" />
        {/each}
    </div>
</ReviewItemFrame>

<style>
    .images {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        align-items: center;
    }
</style>
